/**
 * Authentication contract of the agent WebSockets (`/api/case-discovery-v3/ws`,
 * `/api/hector-agent-edition-v3/ws`).
 *
 * A browser cannot set request headers on a WebSocket handshake; the only
 * client-controlled header is `Sec-WebSocket-Protocol`. The JWT travels there
 * instead of in the URL, because request logs (Render, proxies) record the URL
 * and not that header.
 *
 * The client offers two subprotocols: the fixed {@link WS_AUTH_SUBPROTOCOL},
 * which the server selects and echoes, and one carrying the JWT, which the
 * server reads and never echoes. Browsers abort the connection when they offer
 * subprotocols and the server selects none, hence the fixed one.
 */
export const WS_AUTH_SUBPROTOCOL = 'hector.auth.v1';

const WS_BEARER_SUBPROTOCOL_PREFIX = 'hector.bearer.';

/** Second argument of `new WebSocket(url, protocols)` for an authenticated agent socket. */
export function buildWebSocketAuthProtocols(token: string): string[] {
  return [WS_AUTH_SUBPROTOCOL, `${WS_BEARER_SUBPROTOCOL_PREFIX}${token}`];
}

/** Reads the JWT out of the subprotocols a client offered, or `null` when it offered none. */
export function readWebSocketBearerToken(offeredProtocols: Iterable<string>): string | null {
  for (const protocol of offeredProtocols) {
    if (protocol.startsWith(WS_BEARER_SUBPROTOCOL_PREFIX)) {
      const token = protocol.slice(WS_BEARER_SUBPROTOCOL_PREFIX.length);
      if (token.length > 0) return token;
    }
  }
  return null;
}
